import { Box, Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

interface Props {
  variant: "h1" | "h2" | "h3" | "h4" | "h5";
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  dangerouslySetInnerHTML?: { __html: string };
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
}

const Title = ({ children, variant = "h1", style, className = "", dangerouslySetInnerHTML, align = 'inherit' }: Props) => {
  const html = dangerouslySetInnerHTML ?? (typeof children === 'string' ? { __html: children } : null);
  return (
    <Box className={`Title ${className}`} style={style}>
      {html
        ? <Typography variant={variant} dangerouslySetInnerHTML={html} align={align} />
        : <Typography variant={variant} align={align}>{children}</Typography>
      }
    </Box>
  );
};

export default Title;
